import PropTypes from 'prop-types';
import BetslipSettingsImpl from './betslip-settings.js';
import MojitoCore from 'mojito/core';
import { noop } from 'mojito/utils';

/**
 * Betslip settings component.
 * The default implementation contains a button that shows/hides the settings.
 * When visible, the settings are rendered in a popup.
 *
 * @class BetslipSettings
 * @memberof Mojito.Modules.Betslip.BetslipView
 */

/**
 * BetslipSettings prop types.
 *
 * @property {Function} [onOpenCallback = () => {}] - Callback triggered when settings are opened.
 *
 * @memberof Mojito.Modules.Betslip.BetslipView.BetslipSettings
 */
const propTypes = {
    onOpenCallback: PropTypes.func,
    children: PropTypes.instanceOf(null),
};

const defaultProps = {
    onOpenCallback: noop,
};

export default MojitoCore.Presentation.UIView(
    'BetslipSettings',
    BetslipSettingsImpl,
    propTypes,
    defaultProps
);
